var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn-rs",class:_vm.icone,attrs:{"href":_vm.url,"target":"_blank"}},[_c('i',{class:'fa fa-' + _vm.icone,attrs:{"aria-hidden":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/global/Btn-rs.vue